



































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import LeftTimer from "@/components//JinroPlayer/LeftTimer.vue";
import { JinroPlayerDocument } from "@/services/datatypes";
import { JinroRoles } from "@/services/jinro-roles";
import Jinro from "./Night/NightEachRoles/Jinro.vue";
@Component({
  components: {
    LeftTimer
  }
})
export default class RoleInfo extends Vue {
  get isPlayerUranaishi(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      return this.$store.state.jinroPlayerGame.role === JinroRoles.Uranaishi;
    }
    return false;
  }

  isNewRow(index: number, array: Array<object>): boolean {
    if (!array) {
      return false;
    }
    return index == 0 && array.length !== 1;
  }

  get isPlayerReibaishi(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      return this.$store.state.jinroPlayerGame.role === JinroRoles.Reibaishi;
    }
    return false;
  }

  get isPlayerJinro(): boolean {
    if (this.$store.state.jinroPlayerGame) {
      return this.$store.state.jinroPlayerGame.role === JinroRoles.Jinro;
    }
    return false;
  }

  get jinroPlayers(): Array<JinroPlayerDocument> {
    if (
      !this.$store.state.jinroPlayerGame ||
      !this.$store.state.jinroPlayerGame.playersWithJinroRole
    ) {
      return [];
    }
    return this.$store.state.jinroPlayerGame.playersWithJinroRole;
  }

  get uranaiResults(): any {
    const selectedPlayers = this.selectedPlayers;
    selectedPlayers.reverse();
    return selectedPlayers.map(player => {
      return {
        id: player.id,
        playerName: player.playerName,
        result: player.isJinro ? JinroRoles.Jinro : "人間"
      };
    });
  }
  get selectedPlayers(): Array<any> {
    if (this.$store.state.jinroPlayerGame) {
      const plys: Array<JinroPlayerDocument> = this.$store.state.jinroPlayerGame
        .uranaishiSelectedPlayers;
      return plys ? plys : [];
    }
    return [];
  }
  get reibaiResults(): any {
    const reiResults = this.reiResults;
    reiResults.reverse();
    return reiResults.map(player => {
      return {
        id: player.id,
        playerName: player.playerName,
        result: player.isJinro ? JinroRoles.Jinro : "人間"
      };
    });
  }
  get reiResults(): Array<any> {
    if (this.$store.state.jinroPlayerGame) {
      const plys: Array<JinroPlayerDocument> = this.$store.state.jinroPlayerGame
        .reibaishiReibaiResults;
      return plys ? plys : [];
    }
    return [];
  }
}
